// Flow types automatically removed

import { Component } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { TextArea } from 'dibs-elements/exports/TextArea.tsx';
import styles from './styles/CharacterCountTextArea.scss';

function trimInputValue(props) {
    const { restrictLength, value, max = 0 } = props;
    const useMax = restrictLength && max > 0;
    return useMax && value ? value.substring(0, max) : value;
}

/**
 * Input box that displays a count of characters entered.
 */
export class CharacterCountTextArea extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: trimInputValue(props),
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
            this.setState(() => ({
                value: trimInputValue(nextProps),
            }));
        }
    }

    _onChange = e => {
        const value = e.target.value || '';
        const { restrictLength, max = 0 } = this.props;
        /*  don't restrict the length if there's no max value */

        if (restrictLength && value.length > max && max > 0) {
            e.target.value = value.substring(0, max);
        }

        this.setState({
            value: e.target.value,
        });
    };
    _getRemainingCharacters = value => {
        const chars = (value || '').length;
        return this.props.max - chars;
    };

    render() {
        const { dataTn, disabled } = this.props;
        return (
            <div>
                <TextArea
                    dataTn={dataTn}
                    disabled={disabled}
                    onBlur={this.props.onBlur}
                    onChange={this._onChange}
                    value={this.state.value || ''}
                    rows={3}
                />
                {this.props.max && (
                    <div className={styles.charsLeft}>
                        <FormattedMessage
                            id="dibs-media-uploader.CharacterCountTextArea.charactersLeft"
                            defaultMessage="{count} {count, plural, one {character} other {characters}} left"
                            values={{ count: this._getRemainingCharacters(this.state.value) }}
                        />
                    </div>
                )}
            </div>
        );
    }
}
